import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getGlobalConfigPatch } from './get-options';
import getWebShellClientLocale from "../../utils/get-webshellclient-locale";
var getMarketplace = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getWebShellClientLoc, country, marketplaceId, globalConfig;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _getWebShellClientLoc = getWebShellClientLocale(), country = _getWebShellClientLoc.country, marketplaceId = _getWebShellClientLoc.marketplaceId;
          _context.next = 1;
          return getGlobalConfigPatch();
        case 1:
          globalConfig = _context.sent;
          return _context.abrupt("return", globalConfig !== null && globalConfig !== void 0 && globalConfig.useMarketplaceId ? marketplaceId : country === null || country === void 0 ? void 0 : country.toUpperCase());
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getMarketplace() {
    return _ref.apply(this, arguments);
  };
}();
export default getMarketplace;